import { CheckoutState } from '../../state';
import { shouldShowEventCapacityWaitlistPage } from '../../utils/waitlist';

export const isWaitlistEnabled = (state: CheckoutState) => {
    const {
        app: { waitlistCode },
        event,
        tickets: { ticketsById },
    } = state;

    return shouldShowEventCapacityWaitlistPage(
        event,
        ticketsById,
        waitlistCode,
    );
};
